import React, { useState, useEffect } from "react";
import "./NewuserProfile.css"; // Import CSS for styling
import NavBar from "../../components/NavBar/NavBar";
import OrderHistory from "../OrderHistory/OrderHistory";
import AddAddress from "../Shipping/Shipping";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import NewOrderTracking from "../OrderHistory/OrderTracking/NewOrderTraking";


const NewuserProfile = () => {
  const [activeTab, setActiveTab] = useState("accountDetails"); // State for active tab
  const [loading, setLoading] = useState(false); // Loader state
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    isEmailVerified: false,
  });
  const [emailEdited, setEmailEdited] = useState(false);
  const [verificationMessage, setVerificationMessage] = useState("");
  const [userId, setUserId] = useState(""); // Store user ID
  const location = useLocation();
  // const {message} = location.state

  // Fetch user data (GET request)
  // useEffect(() => {
  //   const fetchUserData = async () => {
  //     try {
  //       const response = await fetch(
  //         "http://147.93.20.174:3002/api/v1/user/getuserdetails",
  //         {
  //           method: "GET",
  //           headers: {
  //             Authorization: `Bearer ${localStorage.getItem("userToken")}`,
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }

  //       const data = await response.json();
  //       setUserData({
  //         firstName: data.user.firstName,
  //         lastName: data.user.lastName,
  //         email: data.user.email,
  //         phone: data.user.phone,
  //       });
  //     } catch (error) {
  //       console.error("Error fetching user data:", error);
  //     }
  //   };

  //   fetchUserData();
  // }, []);

   // Fetch user details on mount
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(
          "https://riymay.com/api/v1/user/getuserdetails",
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setUserData(data.user);
          setUserId(data.user._id); // Save userId for updates
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  // Handle profile update (POST request)
  // const handleProfileUpdate = async (event) => {
  //   event.preventDefault();
  //   try {
  //     const response = await fetch(
  //       "http://147.93.20.174:3002/api/v1/user/profileupdate",
  //       {
  //         method: "POST",
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("userToken")}`,
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(userData),
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     alert("Profile updated successfully!");
  //     console.log("Profile updated:", data);
  //   } catch (error) {
  //     console.error("Error updating profile:", error);
  //   }
  // };

  // Handle profile update
 
  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://riymay.com/api/v1/user/update/user-info/profile", {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        body: JSON.stringify({
          userId,
          firstName: userData.firstName,
          lastName: userData.lastName,
          phone: userData.phone,
        }),
      });

      if (response.ok) {
        // toast.success("Profile updated successfully!", )};

         toast.success( "Profile updated successfully!", {
                position: "top-right",
                autoClose: 3000, // Toast disappears after 3 seconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                toastId:"updateSuccess"
              });
        
            } 



    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  // Handle email edit
  const handleEmailChange = (e) => {
    setUserData({ ...userData, email: e.target.value });
    setEmailEdited(true);
    setVerificationMessage("");
  };

  // Send email verification request
  const sendVerificationEmail = async () => {
    try {
      const response = await fetch("https://riymay.com/api/v1/user/update/user-info/email", {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        body: JSON.stringify({ userId, email: userData.email }),
      });

      const data = await response.json();
      if (response.ok) {
        alert("Verification email sent! Check your inbox.")
        setVerificationMessage("Verification email sent! Check your inbox.");
      } else {
        setVerificationMessage(data.message || "Error sending verification email.");
      }
    } catch (error) {
      console.error("Error sending verification email:", error);
    }
  };

  

  const renderContent = () => {
    switch (activeTab) {
      // case "dashboard":
        // return (
        //   <>
        //     <div className="main-tab-content">
              /* <div className="tab-content">
                <h2>
                  Welcome, <strong>{userData.firstName}</strong>!
                </h2>
                <h4>Your Orders</h4>
                <p>Track, return, or buy things again</p>
                <p>
                  From your account dashboard, you can view your recent orders,
                  manage your shipping and billing addresses, and edit your
                  account details.
                </p>
              </div> */
              /* <div className="tab-content">
            <h2>Welcome, <strong>{userData.firstName}</strong>!</h2>
           
          </div>
          <div className="tab-content">
            <h2>Welcome, <strong>{userData.firstName}</strong>!</h2>
            <p>
              From your account dashboard, 
              you can view your recent orders, manage your shipping and billing addresses, and edit your account details.
            </p>
          </div> */
        //     </div>
        //   </>
        // );
      case "accountDetails":
        return (
          <div className="tab-content">
            {/* <h2>Account Details</h2> */}
            <form className="account-form" onSubmit={handleProfileUpdate}>
              <label>
                First Name:
                <input
                  type="text"
                  value={userData.firstName}
                  onChange={(e) =>
                    setUserData({ ...userData, firstName: e.target.value })
                  }
                />
              </label>
              <label>
                Last Name:
                <input
                  type="text"
                  value={userData.lastName}
                  onChange={(e) =>
                    setUserData({ ...userData, lastName: e.target.value })
                  }
                />
              </label>
              <label>
                Email:
                <input
                  type="email"
                  value={userData.email}
                  onChange={handleEmailChange}
                />
                {emailEdited && (
                  <button type="button" onClick={sendVerificationEmail}>
                    Verify
                  </button>
                )}
                {verificationMessage && <span>{verificationMessage}</span>}
              </label>
              <label>
                Phone:
                <input
                  type="text"
                  value={userData.phone}
                  onChange={(e) =>
                    setUserData({ ...userData, phone: e.target.value })
                  }
                  maxLength={10}
                />
              </label>
              <button type="submit">Save Changes</button>
            </form>
          </div>
        );
      case "orders":
        return (
          <div className="tab-content">
            {/* <h2>Your Orders</h2> */}
            {/* <OrderHistory /> */}
            <NewOrderTracking />

          </div>
        );
      case "addresses":
        return (
          <div className="tab-content">
            <h2>Your Addresses</h2>
            <p>
              <strong>Shipping Address:</strong> Srikanth's Address
            </p>
            {/* <AddAd dress /> */}
          </div>
        );
      default:
        return (
          <div className="tab-content">
            <h2>Welcome to your account!</h2>
          </div>
        );
    }
  };

  return (
    <>
      {/* <NavBar /> */}
      <div className="account-dashboard">
        {/* <div className="breadcrumb">
          <span>Home</span> &gt; <span className="current">My Account</span>
        </div> */}
        <h1 className="title">MY ACCOUNT</h1>
        <div className="dashboard-container">
          <div className="sidebar">
            <ul>
              {/* <li
                className={activeTab === "dashboard" ? "active" : ""}
                onClick={() => setActiveTab("dashboard")}
              >
                Dashboard
              </li> */}
              <h3
               
              >
                {userData.firstName}
              </h3>
              <li
                className={activeTab === "accountDetails" ? "active" : ""}
                onClick={() => setActiveTab("accountDetails")}
              >
                Account details
              </li>
              <li
                className={activeTab === "orders" ? "active" : ""}
                onClick={() => setActiveTab("orders")}
              >
                Orders
              </li>
              {/* <li
                className={activeTab === "addresses" ? "active" : ""}
                onClick={() => setActiveTab("addresses")}
              >
                Addresses
              </li>
              <li>Compare</li>
              <li>Wishlist</li> */}
              {/* <li>Log out</li> */}
            </ul>
          </div>
          <div className="main-content">{renderContent()}</div>
        </div>
      </div>
    </>
  );
};

export default NewuserProfile;
